import React, { useState , useEffect } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useCargosMutations } from '../../hooks/cargos/useCargosMutations';
import { ButtonSubmit, FooterPages } from '..';
import { fetchUser } from '../../utils/fetchUser';

const initialState = {
  codigo: '',
  nombreCargo: '',
  descripcion: '',
  estado: 'ACTIVO',
  codigoERP: '',
  fechaCreacion: '',
};

const Nuevocargo = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addCargo, updateCargoC } = useCargosMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if (vecinoData) {
      setFormData({ ...initialState, ...vecinoData });
    } else {
      setFormData(initialState);
    }
  }, [vecinoData]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones mínimas
    if (!formData.codigo || !formData.nombreCargo) return;
    const userInfo = fetchUser();
    const dataToSend = {
      ...formData,
      empresa: userInfo.empresa,
      estado: formData.estado || 'ACTIVO',
      fechaCreacion: new Date(),
    };
    if (!vecinoData || !vecinoData._id) {
      await addCargo.mutateAsync(dataToSend);
    } else {
      await updateCargoC.mutateAsync({ ...dataToSend, _id: vecinoData._id });
    }
    onChangeVecino('REFRESH');
    setIsClicked(!isClicked.nuevocargo);
  }
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">
          <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nueva" : "Editar"} cargo
              </p>
            </div>
            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevocargo)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          <div className="mt-5 space-y-4">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
              {/* ...campos del formulario... */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Código*</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Ej: CF-029"
                    name="codigo"
                    value={formData.codigo}
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Nombre*</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Nombre del cargo"
                    name="nombreCargo"
                    value={formData.nombreCargo}
                    required
                    onChange={handleChange}
                  />
                </div>
              </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Descripción</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Descripción"
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Código ERP</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Código ERP"
                name="codigoERP"
                value={formData.codigoERP}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Estado</label>
              <select
                className={inputClass}
                name="estado"
                value={formData.estado}
                onChange={handleChange}
              >
                <option value="ACTIVO">ACTIVO</option>
                <option value="INACTIVO">INACTIVO</option>
                <option value="ELIMINADO">ELIMINADO</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 mt-4" >
            <div className="flex flex-col">
              <ButtonSubmit
                color="white"
                bgColor={currentColor}
                text={!vecinoData ? "Crear Nuevo" : "Guardar Cambios"}
                borderRadius="10px"
                onClick={handleSubmit}
                width="full"
              />
            </div>
          </div>
              <FooterPages />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Nuevocargo;